import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { DirectivesModule } from '@shared/directives/directives.module';
import { MaterialModule } from '@app/material/material.module';

import { TabNavComponent } from './tab-nav.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DirectivesModule,
    MaterialModule
  ],
  declarations: [TabNavComponent],
  exports: [TabNavComponent]
})
export class TabNavModule { }
